import { render, staticRenderFns } from "./ContentKontakt.vue?vue&type=template&id=0b5610b0&scoped=true&"
import script from "./ContentKontakt.vue?vue&type=script&lang=js&"
export * from "./ContentKontakt.vue?vue&type=script&lang=js&"
import style0 from "./ContentKontakt.vue?vue&type=style&index=0&id=0b5610b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5610b0",
  null
  
)

export default component.exports